/**
 * Wrap text whose direction may differ from the sentence around it — a chat
 * title in the other script inside a translated message — in Unicode isolates
 * (FSI … PDI), so its digits and punctuation cannot reorder the sentence (an
 * English title in a Hebrew dialog moved the "?" and quotes to the wrong side).
 * The marks are invisible.
 */
export const bidiIsolate = (text: string): string => `⁨${text}⁩`;
